module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_null@2x.307ae4c8.png";